import { createFileRoute } from '@tanstack/react-router'
import ProjectSettings from '../../../../../../containers/ProjectSettings'
import { settingsSearchSchema } from '../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/_projects/settings/$projectId/'
)({
  validateSearch: settingsSearchSchema,
  component: ProjectSettings
})
